export default __webpack_public_path__ + "static/media/home-events-conference-hero-bg.1c967bd7.jpg";